/** @format */

import process from "process";

const apiURL = process.env.REACT_APP_API_URL;
//const token = localStorage.getItem("idToken");
//localStorage.getItem("idToken"),
export async function attachZipADM(
  instanceId,
  docId,
  modelId,
  files,
  token,
  fileExtension,
  clientId,
  json = null
) {
  try {
    const createDocsResponse = await attachementDocADM(
      instanceId,
      docId,
      token,
      modelId,
      fileExtension,
      clientId
    );
    if (createDocsResponse.statusCode === 200) {
      const presignedUrl = createDocsResponse.message.PresignedURL;
      const mimetype = createDocsResponse.message.MimeType;
      await uploadDoc(files, presignedUrl, mimetype).then((response) => {
        return response;
      });
    }
  } catch (error) {
    throw new Error(error);
  }
}

async function attachementDocADM(
  instanceId,
  docId,
  token,
  modelId,
  fileExtension,
  clientId
) {
  try {
    const response = await fetch(apiURL + "/admin/document/attachment/upload", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        DocumentId: docId,
        InstanceId: instanceId,
        ModelId: modelId,
        AttachmentType: fileExtension,
        ClientId: clientId,
      }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(error);
  }
}

async function uploadDoc(file, signedUrl, mimetype) {
  var mypresignedurl = signedUrl;
  var requestOptions = {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": mimetype,
      "Content-Length": file.length,
    },
  };

  try {
    const response = await fetch(mypresignedurl, requestOptions);
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.statusCode}`);
    }
  } catch (error) {
    throw new Error(error);
  }
}
